import { useMall } from "@/context/MallContext";
import { bannerCopy } from "@/components/mall/rooms/banners";

/**
 * The top of a store page: that service's billboard, then one headline and one line of value so
 * somebody landing from Google knows why they are here. Copy is overridable per shop.
 */
export function PageBanner({ room }) {
    const { store } = useMall();
    const b = bannerCopy(room, store);
    if (!b?.Room) return null;
    const { Room } = b;
    return (
        <div data-testid={`page-banner-${room}`}>
            <Room />
            <section className="border-b border-zinc-200 bg-white" data-testid={`page-banner-copy-${room}`}>
                <div className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-5 sm:flex-row sm:items-baseline sm:gap-6 sm:px-6">
                    <h2 className="font-display text-2xl font-black tracking-tight text-zinc-900 sm:text-3xl" data-testid={`page-banner-headline-${room}`}>
                        {b.headline}
                    </h2>
                    <p className="text-sm text-zinc-600 md:text-base" data-testid={`page-banner-line-${room}`}>
                        {b.line}{store?.name ? <span className="text-zinc-400"> · {store.name}</span> : null}
                    </p>
                </div>
            </section>
        </div>
    );
}
